import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const inseminatorObject = z.object({
  id: z.string().uuid(),
  citizenId: z.string().uuid().nullish(),
  code: z.number().int().positive().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  inactivatedAt: dateOrIsoString().nullish(),
})

export type InseminatorType = z.infer<typeof inseminatorObject>

export const propertyMap = {
  id: sql`id`,
  citizenId: sql`citizen_id`,
  code: sql`code`,
  sourceFilter: sql`inseminator.source_filter`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  inactivatedAt: sql`inactivated_at`,
}
